module.exports = __webpack_public_path__ + "static/media/image-3.48718514.png";